import { cleanSession } from 'Utils/session';
import { deepLink } from 'Utils/deepLink';
import Urls from 'Containers/Urls';
import { APPLICATION_REFERRER } from 'Src/consts/constants';

export const purchaseRedirect = () => {
  cleanSession();
  const query = new URLSearchParams(window.location.search);
  const state = query.get('state');
  const code = query.get('code');
  const token = query.get('token');

  const currentPath = window.location.pathname;
  const saveDeeplink = (currentPath !== '/pay/' && currentPath !== '/pay' && currentPath !== '/') && query.size === 0;
  const isVerifying = token && currentPath.startsWith(Urls.verifyAccount);
  const skipRedirect = [Urls.signUp].includes(currentPath) || isVerifying;
  const redirect = (query.size > 0 && (!code && !state)) || saveDeeplink;

  if (window.location.origin !== document.referrer) {
    sessionStorage.setItem(APPLICATION_REFERRER, document.referrer);
  }

  if (saveDeeplink) {
    deepLink.set(`${window.location.pathname}${window.location.search}`);
  }

  if (redirect && !skipRedirect) {
    window.location.assign(`${window.location.origin}${Urls.landing}${window.location.search}`);
  }
};

export default {
  purchaseRedirect,
};
